import { render, staticRenderFns } from "./EditDetail.vue?vue&type=template&id=42e06676&scoped=true&"
import script from "./EditDetail.vue?vue&type=script&lang=js&"
export * from "./EditDetail.vue?vue&type=script&lang=js&"
import style0 from "./EditDetail.vue?vue&type=style&index=0&id=42e06676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e06676",
  null
  
)

export default component.exports